<script setup lang="ts">
import { RouterView } from 'vue-router'
import { useBusinessGlobalStore } from '@/stores/business-global'

// 应用初始化时获取业务全局数据
const businessGlobalStore = useBusinessGlobalStore()
businessGlobalStore.fetchSupplyDemandIdentityDicts()
</script>

<template>
  <RouterView />
</template>

<style scoped></style>
